// Escaped template helpers retained for schema-driven screens and imperative modals.
export class Safe { constructor(public s: string) {} toString() { return this.s; } }
const escapes: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
export const esc = (value: unknown) => String(value ?? '').replace(/[&<>"']/g, char => escapes[char]);
export const raw = (value: unknown) => new Safe(String(value ?? ''));
function fmt(value: unknown): string {
  if (value == null || typeof value === 'boolean') return '';
  if (Array.isArray(value)) return value.map(fmt).join('');
  return value instanceof Safe ? value.s : esc(value);
}
export function html(strings: TemplateStringsArray, ...values: unknown[]): Safe {
  let output = '';
  strings.forEach((str, i) => { output += str; if (i < values.length) output += fmt(values[i]); });
  return new Safe(output);
}
// The selector determines the element subtype at existing template call sites.
export const $ = (selector: string, root: ParentNode = document): any => root.querySelector(selector);
export const $$ = (selector: string, root: ParentNode = document): any[] => [...root.querySelectorAll(selector)];
export function mount(element: HTMLElement, content: unknown) { element.innerHTML = String(content); return element; }
export function on(root: Document | HTMLElement, type: string, selector: string, callback: (event: any, element: any) => void) {
  const handler = (event: Event) => {
    if (!(event.target instanceof Element)) return;
    const element = event.target.closest(selector);
    if (element && root.contains(element)) callback(event, element);
  };
  root.addEventListener(type, handler);
  return () => root.removeEventListener(type, handler);
}
export function toast(message: string) {
  let host = document.querySelector<HTMLElement>('.toast-host');
  if (!host) { host = document.createElement('div'); host.className = 'toast-host'; document.body.append(host); }
  const surface = document.querySelector<HTMLElement>('.app.v2-shell');
  host.classList.toggle('nodex-v2', !!surface);
  if (surface) host.dataset.theme = surface.dataset.theme || 'light';
  else delete host.dataset.theme;
  const item = document.createElement('div');
  item.className = 'toast'; item.textContent = message; host.append(item);
  setTimeout(() => item.remove(), 2600);
}
export function classes(values: Record<string, unknown>) { return Object.entries(values).filter(([, value]) => value).map(([key]) => key).join(' '); }
